var _circle, _mask, _path, _mask2, _path2, _path3, _rect, _rect2, _circle2, _circle3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.3868,
    stroke: "white",
    strokeWidth: 1.22642
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_307_143",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6415 23.1132C22.6415 21.4868 21.9954 19.9271 20.8454 18.7771C19.6954 17.6271 18.1357 16.9811 16.5094 16.9811C14.8831 16.9811 13.3234 17.6271 12.1734 18.7771C11.0234 19.9271 10.3773 21.4868 10.3773 23.1132L11.3579 23.1132C11.3579 21.7469 11.9006 20.4366 12.8667 19.4705C13.8328 18.5044 15.1431 17.9617 16.5094 17.9617C17.8757 17.9617 19.186 18.5044 20.152 19.4705C21.1181 20.4366 21.6609 21.7469 21.6609 23.1132H22.6415Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6415 23.1132C22.6415 21.4868 21.9954 19.9271 20.8454 18.7771C19.6954 17.6271 18.1357 16.9811 16.5094 16.9811C14.8831 16.9811 13.3234 17.6271 12.1734 18.7771C11.0234 19.9271 10.3773 21.4868 10.3773 23.1132L11.3579 23.1132C11.3579 21.7469 11.9006 20.4366 12.8667 19.4705C13.8328 18.5044 15.1431 17.9617 16.5094 17.9617C17.8757 17.9617 19.186 18.5044 20.152 19.4705C21.1181 20.4366 21.6609 21.7469 21.6609 23.1132H22.6415Z",
    stroke: "white",
    strokeWidth: 2.45283,
    mask: "url(#path-2-inside-1_307_143)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_307_143",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5659 23.1132C40.5659 21.4868 39.9199 19.9271 38.7699 18.7771C37.6199 17.6271 36.0602 16.9811 34.4338 16.9811C32.8075 16.9811 31.2478 17.6271 30.0978 18.7771C28.9478 19.9271 28.3018 21.4868 28.3018 23.1132L29.2823 23.1132C29.2823 21.7469 29.8251 20.4366 30.7912 19.4705C31.7573 18.5044 33.0676 17.9617 34.4338 17.9617C35.8001 17.9617 37.1104 18.5044 38.0765 19.4705C39.0426 20.4366 39.5853 21.7469 39.5853 23.1132H40.5659Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5659 23.1132C40.5659 21.4868 39.9199 19.9271 38.7699 18.7771C37.6199 17.6271 36.0602 16.9811 34.4338 16.9811C32.8075 16.9811 31.2478 17.6271 30.0978 18.7771C28.9478 19.9271 28.3018 21.4868 28.3018 23.1132L29.2823 23.1132C29.2823 21.7469 29.8251 20.4366 30.7912 19.4705C31.7573 18.5044 33.0676 17.9617 34.4338 17.9617C35.8001 17.9617 37.1104 18.5044 38.0765 19.4705C39.0426 20.4366 39.5853 21.7469 39.5853 23.1132H40.5659Z",
    stroke: "white",
    strokeWidth: 2.45283,
    mask: "url(#path-3-inside-2_307_143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 31.6038C35.8491 31.6038 34.9057 36.7924 25.4717 36.7924C16.0378 36.7924 15.0944 31.6038 15.0944 31.6038",
    stroke: "white",
    strokeWidth: 1.22642
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.2228,
    y: 30.5789,
    width: 0.943396,
    height: 4.62748,
    transform: "rotate(-60 33.2228 30.5789)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.943396,
    height: 4.62748,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 17.6869 30.5789)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3774,
    cy: 28.3019,
    r: 2.83019,
    fill: "white",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6227,
    cy: 28.3019,
    r: 2.83019,
    fill: "white",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2264 25C46.2264 36.723 36.723 46.2264 25 46.2264C13.277 46.2264 3.7736 36.723 3.7736 25C3.7736 13.277 13.277 3.7736 25 3.7736C28.9851 3.7736 32.7137 4.87179 35.8997 6.78205C35.8997 6.78205 36.4324 6.87858 36.5866 6.65338C36.7097 6.4735 36.5866 6.0952 36.5866 6.0952C33.2149 4.02435 29.2469 2.8302 25 2.8302C12.756 2.8302 2.8302 12.756 2.8302 25C2.8302 37.2441 12.756 47.1698 25 47.1698C37.2441 47.1698 47.1698 37.2441 47.1698 25C47.1698 20.2666 45.6864 15.8797 43.1591 12.2788C43.1591 12.2788 42.6439 12.0651 42.4528 12.2642C42.2655 12.4594 42.4814 12.9565 42.4814 12.9565C44.8433 16.3783 46.2264 20.5276 46.2264 25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.461 11.5976C40.788 10.7721 40.0542 9.99807 39.2663 9.28252C39.2663 9.28252 38.9272 8.70879 39.151 8.49058C39.3726 8.27436 39.9341 8.6147 39.9341 8.6147C40.7205 9.33178 41.455 10.1047 42.1314 10.9272C42.1314 10.9272 42.3554 11.3976 42.1851 11.5976C42.0018 11.8129 41.461 11.5976 41.461 11.5976Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.a5c23523452419005c2f711a0a058c34.svg";
export { ForwardRef as ReactComponent };